import React from 'react'
import rakhi from "../../assets/raki.png"

const Rakhi = () => {
  return (
    <div className="w-full flex flex-col md:flex-row font-sans">

      {/* LEFT — just the photo, no color block. Swap the src below for your own image */}
      <div className="relative w-full md:flex-1 h-[260px] sm:h-[340px] md:h-auto md:min-h-[560px] overflow-hidden">
        <img
          src={rakhi}
          alt="Open photobook with childhood photos"
          className="w-full h-full object-cover"
        />
      </div>

      {/* RIGHT — yellow copy panel */}
      <div className="w-full md:flex-1 bg-[#FFEB3B] flex flex-col items-center justify-center text-center px-6 py-10 sm:px-10 sm:py-12 md:px-16 md:py-14">
        <h1 className="font-serif italic text-[#1a1a2e] text-3xl sm:text-4xl md:text-5xl leading-tight max-w-xs sm:max-w-sm md:max-w-md">
          Your memories deserve a place beyond your phone.
        </h1>

        <p className="mt-5 sm:mt-6 text-[#1a1a2e]/90 text-sm sm:text-[15px] md:text-base leading-relaxed max-w-xs sm:max-w-sm md:max-w-md">
          Celebrate the bond you share with a personalised gift they'll cherish forever. Turn your favourite memories into a beautifully crafted photobook, or discover notebooks, journals, and thoughtful keepsakes made just for your sibling.
        </p>

        <a
          href="/photobook"
          className="mt-7 sm:mt-8 inline-flex items-center gap-2 bg-[#14142b] text-white text-sm font-medium tracking-wide px-5 sm:px-6 py-2.5 sm:py-3 rounded-sm hover:bg-[#26264a] transition-colors"
        >
          Shop Photobooks
          <span aria-hidden="true">›</span>
        </a>
      </div>
    </div>
  )
}

export default Rakhi